<template>
  <form :class="`${isBoxed ? 'box' : ''}`" @submit.prevent="handleSubmit" name="login-form">
    <b-field :type="userFieldType"
             :message="userMessage"
             label="Username Or Email"> <!--custom-class="is-large"-->
      <b-input v-model="user"
               @input="() => removeMessage('user')"
               name="user"
               type="text"
               icon="shield-account"
               :disabled="resetEmailSent" /> <!-- size="is-large" -->
    </b-field>

    <b-field v-if="!userForgotPass"
             :type="passFieldType"
             label="Password"
             :message="passMessage"> <!-- custom-class="is-large" -->
      <b-input v-model="pass"
               @input="() => removeMessage('pass')"
               type="password"
               name="password"
               password-reveal
               icon="lock" /> <!-- size="is-large" -->
    </b-field>

    <div class="buttons is-centered">
      <b-button :loading="loggingIn"
                native-type="submit"
                :disabled="((!pass || !user) && !userForgotPass) || resetEmailSent"> <!-- size="is-large" @click.prevent="handleSubmit"-->
        {{ userForgotPass ? 'Send Password' : 'Login' }}
      </b-button>
      <b-button v-if="userForgotPass"
                @click.prevent="userForgotPass = false"
                icon-left="close"
                type="is-text"
                :disabled="resetEmailSent"> <!-- size="is-large" -->
        Cancel
      </b-button>
    </div>

    <div class="buttons is-right">
      <b-button v-if="!userForgotPass"
                type="is-text"
                @click.prevent="userForgotPass = true"
                size="is-small">
        Forgot Password
      </b-button>
      <b-button v-if="$route.path !== '/sign-up' && hasSalesVid" type="is-text" @click="goToSignUp" size="is-small">Learn More</b-button>
    </div>

  </form>
</template>

<script>
import { login, sendResetPasswordEmail } from '@/utils/api';

export default {
  props: {
    isBoxed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loggingIn: false,
      user: '',
      userMessage: null,
      pass: '',
      passMessage: null,
      userForgotPass: false,
      resetEmailSent: false,
      hasSalesVid: process.env.VUE_APP_SIGN_UP_VID
    }
  },
  methods: {
    goToSignUp: function () {
      this.$router.push('/sign-up');
    },
    sendResetPasswordEmail: function () {
      let {user} = this;
      this.loggingIn = true;

      sendResetPasswordEmail(user)
      .then(async res => {
        if (!res.ok) {
          return this.userMessage = 'User Not Found';
        }

        this.resetEmailSent = true;
        this.$buefy.toast.open({
          message: 'Password Rest Instructions Sent',
          type: 'is-success',
          duration: 10000
        })
      })
      .finally(() => this.loggingIn = false);
    },
    handleSubmit: function () {
      let {userForgotPass} = this;

      if (!userForgotPass) {
        return this.login();
      }

      return this.sendResetPasswordEmail()
    },
    login: function() {
      let {user, pass} = this;
      this.loggingIn = true;

      login({user, pass})
      .then(async res => {
        let response = await res.json();
        let {usr, result = {}, success} = response;

        if (success && usr) {
          let redirectDest = usr.admin_id ? '/admin' : process.env.VUE_APP_IS_MODULES_ONLY ? '/modules' : '/';
          localStorage.setItem('user', JSON.stringify(usr));

          this.$emit('userUpdated');

          return this.$router.push({
            path: redirectDest,
            query: this.$route.query
          });
        }

        if (result.for === 'user') {
          this.userMessage = result.message;
        }

        if (result.for === 'pass') {
          this.passMessage = result.message;
        }

        if (result.for === 'all') {
          this.$buefy.toast.open({
            duration: 7000,
            message: result.message,
            type: 'is-danger'
          });
        }
      })
      .catch(err => {
        console.error(err);
        this.$buefy.toast.open({
          duration: 7000,
          message: err.message,
          type: 'is-danger'
        });
      })
      .finally(() => {
        this.loggingIn = false;
      });
    },
    removeMessage: function (userOrPass) {
      if (userOrPass === 'user') {
        this.userMessage = null;
      }

      if (userOrPass === 'pass') {
        this.passMessage = null;
      }
    }
  },
  computed: {
    userFieldType: function () {
      let {user, userMessage} = this;

      if (userMessage) {
        return 'is-danger';
      }

      if (!user) {
        return undefined;
      }

      return 'is-success';
    },
    passFieldType: function () {
      let {pass, passMessage} = this;

      if (passMessage) {
        return 'is-danger';
      }

      if (!pass) {
        return undefined;
      }

      return 'is-success';
    }
  }
}
</script>